/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Avatar1({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/Tag/Payer/Relationships/Content/Relationship/Avatar"
  
}) {
let dependentPersonToPersonRecordValueData = fromData.useDataFormat({ viewPath,
context: 'dependentPerson',
path: 'to_person_record',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 size="medium"
 marginRight={dtSpaceXs}
 data="dependentPerson.to_person_record"
 format="/Data/format.js initials"
 initials={dependentPersonToPersonRecordValueData}
/>
{children}
</React.Fragment>)
}